/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppRouteImport } from './routes/app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppIndexRouteImport } from './routes/app/index'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as AppSettingsRouteImport } from './routes/app/settings'
import { Route as AppSearchRouteImport } from './routes/app/search'
import { Route as AppReportsRouteImport } from './routes/app/reports'
import { Route as AppProjectsRouteImport } from './routes/app/projects'
import { Route as AppNotificationsRouteImport } from './routes/app/notifications'
import { Route as AppMyPlaniRouteImport } from './routes/app/my-plani'
import { Route as AppMachinesRouteImport } from './routes/app/machines'
import { Route as AppKnowledgeRouteImport } from './routes/app/knowledge'
import { Route as AppInicioRouteImport } from './routes/app/inicio'
import { Route as AppDevopsRouteImport } from './routes/app/devops'
import { Route as AppDashboardsRouteImport } from './routes/app/dashboards'
import { Route as AppClientsRouteImport } from './routes/app/clients'
import { Route as AppCertificationsRouteImport } from './routes/app/certifications'
import { Route as AppCalendarYearRouteImport } from './routes/app/calendar-year'
import { Route as AppAdminRouteImport } from './routes/app/admin'
import { Route as AppDevopsIndexRouteImport } from './routes/app/devops.index'
import { Route as AppDashboardsIndexRouteImport } from './routes/app/dashboards.index'
import { Route as AppTTaskRefRouteImport } from './routes/app/t/$taskRef'
import { Route as AppSpacesSpaceIdRouteImport } from './routes/app/spaces/$spaceId'
import { Route as AppSSpaceRefRouteImport } from './routes/app/s/$spaceRef'
import { Route as AppPProjectRefRouteImport } from './routes/app/p/$projectRef'
import { Route as AppLListRefRouteImport } from './routes/app/l/$listRef'
import { Route as AppDevopsClienteRefRouteImport } from './routes/app/devops.$clienteRef'
import { Route as AppDashboardsDashboardIdRouteImport } from './routes/app/dashboards.$dashboardId'
import { Route as AppSpacesSpaceIdListsListIdRouteImport } from './routes/app/spaces/$spaceId/lists/$listId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppSearchRoute = AppSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsRoute = AppReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsRoute = AppProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => AppRoute,
} as any)
const AppNotificationsRoute = AppNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AppRoute,
} as any)
const AppMyPlaniRoute = AppMyPlaniRouteImport.update({
  id: '/my-plani',
  path: '/my-plani',
  getParentRoute: () => AppRoute,
} as any)
const AppMachinesRoute = AppMachinesRouteImport.update({
  id: '/machines',
  path: '/machines',
  getParentRoute: () => AppRoute,
} as any)
const AppKnowledgeRoute = AppKnowledgeRouteImport.update({
  id: '/knowledge',
  path: '/knowledge',
  getParentRoute: () => AppRoute,
} as any)
const AppInicioRoute = AppInicioRouteImport.update({
  id: '/inicio',
  path: '/inicio',
  getParentRoute: () => AppRoute,
} as any)
const AppDevopsRoute = AppDevopsRouteImport.update({
  id: '/devops',
  path: '/devops',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardsRoute = AppDashboardsRouteImport.update({
  id: '/dashboards',
  path: '/dashboards',
  getParentRoute: () => AppRoute,
} as any)
const AppClientsRoute = AppClientsRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => AppRoute,
} as any)
const AppCertificationsRoute = AppCertificationsRouteImport.update({
  id: '/certifications',
  path: '/certifications',
  getParentRoute: () => AppRoute,
} as any)
const AppCalendarYearRoute = AppCalendarYearRouteImport.update({
  id: '/calendar-year',
  path: '/calendar-year',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminRoute = AppAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRoute,
} as any)
const AppDevopsIndexRoute = AppDevopsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppDevopsRoute,
} as any)
const AppDashboardsIndexRoute = AppDashboardsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppDashboardsRoute,
} as any)
const AppTTaskRefRoute = AppTTaskRefRouteImport.update({
  id: '/t/$taskRef',
  path: '/t/$taskRef',
  getParentRoute: () => AppRoute,
} as any)
const AppSpacesSpaceIdRoute = AppSpacesSpaceIdRouteImport.update({
  id: '/spaces/$spaceId',
  path: '/spaces/$spaceId',
  getParentRoute: () => AppRoute,
} as any)
const AppSSpaceRefRoute = AppSSpaceRefRouteImport.update({
  id: '/s/$spaceRef',
  path: '/s/$spaceRef',
  getParentRoute: () => AppRoute,
} as any)
const AppPProjectRefRoute = AppPProjectRefRouteImport.update({
  id: '/p/$projectRef',
  path: '/p/$projectRef',
  getParentRoute: () => AppRoute,
} as any)
const AppLListRefRoute = AppLListRefRouteImport.update({
  id: '/l/$listRef',
  path: '/l/$listRef',
  getParentRoute: () => AppRoute,
} as any)
const AppDevopsClienteRefRoute = AppDevopsClienteRefRouteImport.update({
  id: '/$clienteRef',
  path: '/$clienteRef',
  getParentRoute: () => AppDevopsRoute,
} as any)
const AppDashboardsDashboardIdRoute =
  AppDashboardsDashboardIdRouteImport.update({
    id: '/$dashboardId',
    path: '/$dashboardId',
    getParentRoute: () => AppDashboardsRoute,
  } as any)
const AppSpacesSpaceIdListsListIdRoute =
  AppSpacesSpaceIdListsListIdRouteImport.update({
    id: '/lists/$listId',
    path: '/lists/$listId',
    getParentRoute: () => AppSpacesSpaceIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/app/admin': typeof AppAdminRoute
  '/app/calendar-year': typeof AppCalendarYearRoute
  '/app/certifications': typeof AppCertificationsRoute
  '/app/clients': typeof AppClientsRoute
  '/app/dashboards': typeof AppDashboardsRouteWithChildren
  '/app/devops': typeof AppDevopsRouteWithChildren
  '/app/inicio': typeof AppInicioRoute
  '/app/knowledge': typeof AppKnowledgeRoute
  '/app/machines': typeof AppMachinesRoute
  '/app/my-plani': typeof AppMyPlaniRoute
  '/app/notifications': typeof AppNotificationsRoute
  '/app/projects': typeof AppProjectsRoute
  '/app/reports': typeof AppReportsRoute
  '/app/search': typeof AppSearchRoute
  '/app/settings': typeof AppSettingsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/app/': typeof AppIndexRoute
  '/app/dashboards/$dashboardId': typeof AppDashboardsDashboardIdRoute
  '/app/devops/$clienteRef': typeof AppDevopsClienteRefRoute
  '/app/l/$listRef': typeof AppLListRefRoute
  '/app/p/$projectRef': typeof AppPProjectRefRoute
  '/app/s/$spaceRef': typeof AppSSpaceRefRoute
  '/app/spaces/$spaceId': typeof AppSpacesSpaceIdRouteWithChildren
  '/app/t/$taskRef': typeof AppTTaskRefRoute
  '/app/dashboards/': typeof AppDashboardsIndexRoute
  '/app/devops/': typeof AppDevopsIndexRoute
  '/app/spaces/$spaceId/lists/$listId': typeof AppSpacesSpaceIdListsListIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/app/admin': typeof AppAdminRoute
  '/app/calendar-year': typeof AppCalendarYearRoute
  '/app/certifications': typeof AppCertificationsRoute
  '/app/clients': typeof AppClientsRoute
  '/app/inicio': typeof AppInicioRoute
  '/app/knowledge': typeof AppKnowledgeRoute
  '/app/machines': typeof AppMachinesRoute
  '/app/my-plani': typeof AppMyPlaniRoute
  '/app/notifications': typeof AppNotificationsRoute
  '/app/projects': typeof AppProjectsRoute
  '/app/reports': typeof AppReportsRoute
  '/app/search': typeof AppSearchRoute
  '/app/settings': typeof AppSettingsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/app': typeof AppIndexRoute
  '/app/dashboards/$dashboardId': typeof AppDashboardsDashboardIdRoute
  '/app/devops/$clienteRef': typeof AppDevopsClienteRefRoute
  '/app/l/$listRef': typeof AppLListRefRoute
  '/app/p/$projectRef': typeof AppPProjectRefRoute
  '/app/s/$spaceRef': typeof AppSSpaceRefRoute
  '/app/spaces/$spaceId': typeof AppSpacesSpaceIdRouteWithChildren
  '/app/t/$taskRef': typeof AppTTaskRefRoute
  '/app/dashboards': typeof AppDashboardsIndexRoute
  '/app/devops': typeof AppDevopsIndexRoute
  '/app/spaces/$spaceId/lists/$listId': typeof AppSpacesSpaceIdListsListIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/app/admin': typeof AppAdminRoute
  '/app/calendar-year': typeof AppCalendarYearRoute
  '/app/certifications': typeof AppCertificationsRoute
  '/app/clients': typeof AppClientsRoute
  '/app/dashboards': typeof AppDashboardsRouteWithChildren
  '/app/devops': typeof AppDevopsRouteWithChildren
  '/app/inicio': typeof AppInicioRoute
  '/app/knowledge': typeof AppKnowledgeRoute
  '/app/machines': typeof AppMachinesRoute
  '/app/my-plani': typeof AppMyPlaniRoute
  '/app/notifications': typeof AppNotificationsRoute
  '/app/projects': typeof AppProjectsRoute
  '/app/reports': typeof AppReportsRoute
  '/app/search': typeof AppSearchRoute
  '/app/settings': typeof AppSettingsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/app/': typeof AppIndexRoute
  '/app/dashboards/$dashboardId': typeof AppDashboardsDashboardIdRoute
  '/app/devops/$clienteRef': typeof AppDevopsClienteRefRoute
  '/app/l/$listRef': typeof AppLListRefRoute
  '/app/p/$projectRef': typeof AppPProjectRefRoute
  '/app/s/$spaceRef': typeof AppSSpaceRefRoute
  '/app/spaces/$spaceId': typeof AppSpacesSpaceIdRouteWithChildren
  '/app/t/$taskRef': typeof AppTTaskRefRoute
  '/app/dashboards/': typeof AppDashboardsIndexRoute
  '/app/devops/': typeof AppDevopsIndexRoute
  '/app/spaces/$spaceId/lists/$listId': typeof AppSpacesSpaceIdListsListIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/app'
    | '/login'
    | '/app/admin'
    | '/app/calendar-year'
    | '/app/certifications'
    | '/app/clients'
    | '/app/dashboards'
    | '/app/devops'
    | '/app/inicio'
    | '/app/knowledge'
    | '/app/machines'
    | '/app/my-plani'
    | '/app/notifications'
    | '/app/projects'
    | '/app/reports'
    | '/app/search'
    | '/app/settings'
    | '/auth/callback'
    | '/app/'
    | '/app/dashboards/$dashboardId'
    | '/app/devops/$clienteRef'
    | '/app/l/$listRef'
    | '/app/p/$projectRef'
    | '/app/s/$spaceRef'
    | '/app/spaces/$spaceId'
    | '/app/t/$taskRef'
    | '/app/dashboards/'
    | '/app/devops/'
    | '/app/spaces/$spaceId/lists/$listId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/app/admin'
    | '/app/calendar-year'
    | '/app/certifications'
    | '/app/clients'
    | '/app/inicio'
    | '/app/knowledge'
    | '/app/machines'
    | '/app/my-plani'
    | '/app/notifications'
    | '/app/projects'
    | '/app/reports'
    | '/app/search'
    | '/app/settings'
    | '/auth/callback'
    | '/app'
    | '/app/dashboards/$dashboardId'
    | '/app/devops/$clienteRef'
    | '/app/l/$listRef'
    | '/app/p/$projectRef'
    | '/app/s/$spaceRef'
    | '/app/spaces/$spaceId'
    | '/app/t/$taskRef'
    | '/app/dashboards'
    | '/app/devops'
    | '/app/spaces/$spaceId/lists/$listId'
  id:
    | '__root__'
    | '/'
    | '/app'
    | '/login'
    | '/app/admin'
    | '/app/calendar-year'
    | '/app/certifications'
    | '/app/clients'
    | '/app/dashboards'
    | '/app/devops'
    | '/app/inicio'
    | '/app/knowledge'
    | '/app/machines'
    | '/app/my-plani'
    | '/app/notifications'
    | '/app/projects'
    | '/app/reports'
    | '/app/search'
    | '/app/settings'
    | '/auth/callback'
    | '/app/'
    | '/app/dashboards/$dashboardId'
    | '/app/devops/$clienteRef'
    | '/app/l/$listRef'
    | '/app/p/$projectRef'
    | '/app/s/$spaceRef'
    | '/app/spaces/$spaceId'
    | '/app/t/$taskRef'
    | '/app/dashboards/'
    | '/app/devops/'
    | '/app/spaces/$spaceId/lists/$listId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/settings': {
      id: '/app/settings'
      path: '/settings'
      fullPath: '/app/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/search': {
      id: '/app/search'
      path: '/search'
      fullPath: '/app/search'
      preLoaderRoute: typeof AppSearchRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/reports': {
      id: '/app/reports'
      path: '/reports'
      fullPath: '/app/reports'
      preLoaderRoute: typeof AppReportsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/projects': {
      id: '/app/projects'
      path: '/projects'
      fullPath: '/app/projects'
      preLoaderRoute: typeof AppProjectsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/notifications': {
      id: '/app/notifications'
      path: '/notifications'
      fullPath: '/app/notifications'
      preLoaderRoute: typeof AppNotificationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/my-plani': {
      id: '/app/my-plani'
      path: '/my-plani'
      fullPath: '/app/my-plani'
      preLoaderRoute: typeof AppMyPlaniRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/machines': {
      id: '/app/machines'
      path: '/machines'
      fullPath: '/app/machines'
      preLoaderRoute: typeof AppMachinesRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/knowledge': {
      id: '/app/knowledge'
      path: '/knowledge'
      fullPath: '/app/knowledge'
      preLoaderRoute: typeof AppKnowledgeRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/inicio': {
      id: '/app/inicio'
      path: '/inicio'
      fullPath: '/app/inicio'
      preLoaderRoute: typeof AppInicioRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/devops': {
      id: '/app/devops'
      path: '/devops'
      fullPath: '/app/devops'
      preLoaderRoute: typeof AppDevopsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/dashboards': {
      id: '/app/dashboards'
      path: '/dashboards'
      fullPath: '/app/dashboards'
      preLoaderRoute: typeof AppDashboardsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/clients': {
      id: '/app/clients'
      path: '/clients'
      fullPath: '/app/clients'
      preLoaderRoute: typeof AppClientsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/certifications': {
      id: '/app/certifications'
      path: '/certifications'
      fullPath: '/app/certifications'
      preLoaderRoute: typeof AppCertificationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/calendar-year': {
      id: '/app/calendar-year'
      path: '/calendar-year'
      fullPath: '/app/calendar-year'
      preLoaderRoute: typeof AppCalendarYearRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/admin': {
      id: '/app/admin'
      path: '/admin'
      fullPath: '/app/admin'
      preLoaderRoute: typeof AppAdminRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/devops/': {
      id: '/app/devops/'
      path: '/'
      fullPath: '/app/devops/'
      preLoaderRoute: typeof AppDevopsIndexRouteImport
      parentRoute: typeof AppDevopsRoute
    }
    '/app/dashboards/': {
      id: '/app/dashboards/'
      path: '/'
      fullPath: '/app/dashboards/'
      preLoaderRoute: typeof AppDashboardsIndexRouteImport
      parentRoute: typeof AppDashboardsRoute
    }
    '/app/t/$taskRef': {
      id: '/app/t/$taskRef'
      path: '/t/$taskRef'
      fullPath: '/app/t/$taskRef'
      preLoaderRoute: typeof AppTTaskRefRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/spaces/$spaceId': {
      id: '/app/spaces/$spaceId'
      path: '/spaces/$spaceId'
      fullPath: '/app/spaces/$spaceId'
      preLoaderRoute: typeof AppSpacesSpaceIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/s/$spaceRef': {
      id: '/app/s/$spaceRef'
      path: '/s/$spaceRef'
      fullPath: '/app/s/$spaceRef'
      preLoaderRoute: typeof AppSSpaceRefRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/p/$projectRef': {
      id: '/app/p/$projectRef'
      path: '/p/$projectRef'
      fullPath: '/app/p/$projectRef'
      preLoaderRoute: typeof AppPProjectRefRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/l/$listRef': {
      id: '/app/l/$listRef'
      path: '/l/$listRef'
      fullPath: '/app/l/$listRef'
      preLoaderRoute: typeof AppLListRefRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/devops/$clienteRef': {
      id: '/app/devops/$clienteRef'
      path: '/$clienteRef'
      fullPath: '/app/devops/$clienteRef'
      preLoaderRoute: typeof AppDevopsClienteRefRouteImport
      parentRoute: typeof AppDevopsRoute
    }
    '/app/dashboards/$dashboardId': {
      id: '/app/dashboards/$dashboardId'
      path: '/$dashboardId'
      fullPath: '/app/dashboards/$dashboardId'
      preLoaderRoute: typeof AppDashboardsDashboardIdRouteImport
      parentRoute: typeof AppDashboardsRoute
    }
    '/app/spaces/$spaceId/lists/$listId': {
      id: '/app/spaces/$spaceId/lists/$listId'
      path: '/lists/$listId'
      fullPath: '/app/spaces/$spaceId/lists/$listId'
      preLoaderRoute: typeof AppSpacesSpaceIdListsListIdRouteImport
      parentRoute: typeof AppSpacesSpaceIdRoute
    }
  }
}

interface AppDashboardsRouteChildren {
  AppDashboardsDashboardIdRoute: typeof AppDashboardsDashboardIdRoute
  AppDashboardsIndexRoute: typeof AppDashboardsIndexRoute
}

const AppDashboardsRouteChildren: AppDashboardsRouteChildren = {
  AppDashboardsDashboardIdRoute: AppDashboardsDashboardIdRoute,
  AppDashboardsIndexRoute: AppDashboardsIndexRoute,
}

const AppDashboardsRouteWithChildren = AppDashboardsRoute._addFileChildren(
  AppDashboardsRouteChildren,
)

interface AppDevopsRouteChildren {
  AppDevopsClienteRefRoute: typeof AppDevopsClienteRefRoute
  AppDevopsIndexRoute: typeof AppDevopsIndexRoute
}

const AppDevopsRouteChildren: AppDevopsRouteChildren = {
  AppDevopsClienteRefRoute: AppDevopsClienteRefRoute,
  AppDevopsIndexRoute: AppDevopsIndexRoute,
}

const AppDevopsRouteWithChildren = AppDevopsRoute._addFileChildren(
  AppDevopsRouteChildren,
)

interface AppSpacesSpaceIdRouteChildren {
  AppSpacesSpaceIdListsListIdRoute: typeof AppSpacesSpaceIdListsListIdRoute
}

const AppSpacesSpaceIdRouteChildren: AppSpacesSpaceIdRouteChildren = {
  AppSpacesSpaceIdListsListIdRoute: AppSpacesSpaceIdListsListIdRoute,
}

const AppSpacesSpaceIdRouteWithChildren =
  AppSpacesSpaceIdRoute._addFileChildren(AppSpacesSpaceIdRouteChildren)

interface AppRouteChildren {
  AppAdminRoute: typeof AppAdminRoute
  AppCalendarYearRoute: typeof AppCalendarYearRoute
  AppCertificationsRoute: typeof AppCertificationsRoute
  AppClientsRoute: typeof AppClientsRoute
  AppDashboardsRoute: typeof AppDashboardsRouteWithChildren
  AppDevopsRoute: typeof AppDevopsRouteWithChildren
  AppInicioRoute: typeof AppInicioRoute
  AppKnowledgeRoute: typeof AppKnowledgeRoute
  AppMachinesRoute: typeof AppMachinesRoute
  AppMyPlaniRoute: typeof AppMyPlaniRoute
  AppNotificationsRoute: typeof AppNotificationsRoute
  AppProjectsRoute: typeof AppProjectsRoute
  AppReportsRoute: typeof AppReportsRoute
  AppSearchRoute: typeof AppSearchRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppIndexRoute: typeof AppIndexRoute
  AppLListRefRoute: typeof AppLListRefRoute
  AppPProjectRefRoute: typeof AppPProjectRefRoute
  AppSSpaceRefRoute: typeof AppSSpaceRefRoute
  AppSpacesSpaceIdRoute: typeof AppSpacesSpaceIdRouteWithChildren
  AppTTaskRefRoute: typeof AppTTaskRefRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAdminRoute: AppAdminRoute,
  AppCalendarYearRoute: AppCalendarYearRoute,
  AppCertificationsRoute: AppCertificationsRoute,
  AppClientsRoute: AppClientsRoute,
  AppDashboardsRoute: AppDashboardsRouteWithChildren,
  AppDevopsRoute: AppDevopsRouteWithChildren,
  AppInicioRoute: AppInicioRoute,
  AppKnowledgeRoute: AppKnowledgeRoute,
  AppMachinesRoute: AppMachinesRoute,
  AppMyPlaniRoute: AppMyPlaniRoute,
  AppNotificationsRoute: AppNotificationsRoute,
  AppProjectsRoute: AppProjectsRoute,
  AppReportsRoute: AppReportsRoute,
  AppSearchRoute: AppSearchRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppIndexRoute: AppIndexRoute,
  AppLListRefRoute: AppLListRefRoute,
  AppPProjectRefRoute: AppPProjectRefRoute,
  AppSSpaceRefRoute: AppSSpaceRefRoute,
  AppSpacesSpaceIdRoute: AppSpacesSpaceIdRouteWithChildren,
  AppTTaskRefRoute: AppTTaskRefRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  AuthCallbackRoute: AuthCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
